<script setup>
import { ref, onMounted } from 'vue';
import { $api } from '@/services';
import Loading from '@/components/common/Loading';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import EditMenuByDay from './EditMenuByDay.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import DuplicateMenu from './DuplicateMenu.vue';
import Delete from './Delete.vue';
import { useRoute } from 'vue-router';
import UpdateMenu from './UpdateMenu.vue';
import DuplicateWeekMenu from './DuplicateWeekMenu.vue';
import SendMenuToParent from './SendMenuToParent.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();
const sideOverShow = ref(false);
const isLoading = ref(false);
const menuDetail = ref({});
const modalIsOpen = ref(false);
const type = ref('');
const route = useRoute();
const dow = ref(null);
const content = ref('');
const startDate = ref(null);

onMounted(() => {
	getMenuDetail();
});

async function getMenuDetail() {
	try {
		const res = await $api.menu.getMenuDetail(route.params.id);
		menuDetail.value = res.data.data;
	} catch (error) {
		console.log(error);
	}
}
function editMenuByDay(index) {
	type.value = 'edit';
	dow.value = index;
	sideOverShow.value = true;
}
function duplicateMenuByDay(index) {
	dow.value = index;
	type.value = 'duplicate';
	modalIsOpen.value = true;
}
function deleteMenuByDay(index) {
	dow.value = index;
	type.value = 'delete';
	modalIsOpen.value = true;
}
function getDishes(week, mealId, day) {
	const mealGroup = week.menu_details.find((m) => m.meal_id === mealId);
	if (!mealGroup) return [];
	const dayGroup = mealGroup.menu_details.find((d) => d.day_of_week === day);
	if (!dayGroup) return [];
	const detail = dayGroup.menu_details[0];
	if (!detail) return [];
	return detail.menu_item_dishes || [];
}
function formatDate(date) {
	if (!date) return '';
	return date.split('-').reverse().join('/');
}
function updateSuccess() {
	if (type.value === 'duplicateWeek') return router.push('/menu');
	getMenuDetail();
	modalIsOpen.value = false;
	sideOverShow.value = false;
}
function editMenuByWeek() {
	type.value = 'create';
	modalIsOpen.value = true;
}
function duplicateWeekMenu(week_start) {
	startDate.value = week_start;
	type.value = 'duplicateWeek';
	modalIsOpen.value = true;
}
function sendMenuToParent() {
	type.value = 'send';
	content.value = `Thực đơn Tuần (${formatDate(menuDetail.value?.start_date)}
										- ${formatDate(menuDetail.value?.end_date)})`;
	sideOverShow.value = true;
}
function openDeleteModal() {
	type.value = 'deleteMenu';
	modalIsOpen.value = true;
}

async function deleteMenu() {
	try {
		await $api.menu.deleteMenu(menuDetail.value.id);
		modalIsOpen.value = false;
		await store.dispatch('setAlertMessage', {
			message: 'Xoá thực đơn thành công',
			type: 'success',
		});
		router.push('/menu');
	} catch (error) {
		console.log(error);
		await store.dispatch('setAlertMessage', {
			message:
				error?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

async function deleteDay() {
	try {
		await $api.menu.updateMenuByDay(menuDetail.value.id, {
			day_of_week: dow.value,
			menu_id: menuDetail.value.id,
			menu_details: [],
		});
		updateSuccess();
	} catch (error) {
		console.log(error);
	}
}

function todayYmd() {
	const d = new Date();
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${y}-${m}-${day}`;
}

function isWeekStartBeforeToday(startDate) {
	if (!startDate) return false;
	return startDate > todayYmd();
}
</script>
<template>
	<div v-if="sideOverShow" :class="sideOverShow ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="sideOverShow = false"
		></div>
		<EditMenuByDay
			v-if="type === 'edit'"
			@close="sideOverShow = false"
			:menuDetail="menuDetail"
			:dow="dow"
			@success="updateSuccess"
			:openModal="sideOverShow"
		/>
		<SendMenuToParent
			v-if="type === 'send'"
			@close="sideOverShow = false"
			:menuId="menuDetail.id"
			:content="content"
		/>
	</div>
	<DaModalFrame v-model:open="modalIsOpen">
		<DuplicateMenu
			v-if="type === 'duplicate'"
			@close="modalIsOpen = false"
			:dow="dow"
			:menuDetail="menuDetail"
			@success="updateSuccess"
		/>
		<Delete
			v-if="type === 'delete'"
			:text="`Bạn có muốn xoá nội dung của
		ngày này?`"
			:textUnder="`Nội dung này sẽ được xoá khỏi dữ liệu của cơ sở.`"
			@close="modalIsOpen = false"
			:dow="dow"
			@submit="deleteDay"
		/>
		<UpdateMenu
			v-if="type === 'create'"
			:listMeals="listMeals"
			@close="modalIsOpen = false"
			@success="updateSuccess"
			:weekDetail="menuDetail"
			:openModal="modalIsOpen"
		/>
		<Delete
			v-if="type === 'deleteMenu'"
			:text="`Bạn có muốn xoá thực đơn này?`"
			:textUnder="`Thực đơn này sẽ được xoá khỏi dữ liệu của cơ sở.`"
			@close="modalIsOpen = false"
			@submit="deleteMenu"
		/>
		<DuplicateWeekMenu
			v-if="type === 'duplicateWeek'"
			@close="modalIsOpen = false"
			:menuId="menuDetail.id"
			@success="updateSuccess"
			:startDate="startDate"
		/>
	</DaModalFrame>
	<div class="px-12 md-down:px-4 pb-30">
		<div class="__report-lesson__header pt-10 pb-4">
			<div class="flex items-center justify-between">
				<div
					class="flex items-center gap-3 mb-2 text-neutral-500 text-sm font-semibold"
				>
					<div class="cursor-pointer" @click="$router.push('/menu')">
						Thực đơn
					</div>
					<img alt="" src="@/assets/images/icons/arrow-right.png" />
					<div>Chỉnh sửa thực đơn</div>
				</div>
				<div
					class="flex items-center gap-1 cursor-pointer"
					@click="$router.push('/menu')"
				>
					<img src="@/assets/images/icons/exit.png" alt="" />
					<div class="font-semibold text-sm text-neutral-500">
						Thoát
					</div>
				</div>
			</div>
		</div>
		<div
			class="text-neutral-700 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-2"
		>
			<svg
				class="cursor-pointer"
				width="28"
				height="28"
				viewBox="0 0 28 28"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				@click="$router.push('/menu')"
			>
				<path
					d="M17.5 7L10.5 14L17.5 21"
					stroke="#94A3B8"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
			<img
				v-if="menuDetail.state === 'completed'"
				class="w-5 h-5"
				src="@/assets/images/icons/green-circle.png"
				alt=""
			/>
			<img v-else src="@/assets/images/icons/lock.png" alt="" />
			<div>
				Thực đơn Tuần ({{ formatDate(menuDetail?.start_date) }} -
				{{ formatDate(menuDetail?.end_date) }})
			</div>
		</div>
		<div class="text-green-500 text-xs font-semibold">
			{{ menuDetail.state === 'completed' ? 'HOÀN THÀNH' : 'BẢN NHÁP' }}
			| TẠO BỞI
			<span class="text-blue-600 text-sm">{{
				menuDetail?.created_by_staff?.full_name
			}}</span>
			| LÚC {{ $filters.formatDateTime(menuDetail.inserted_at) }}
		</div>
		<div class="w-full">
			<div class="flex justify-end w-full">
				<Menu as="div" class="ml-3 relative">
					<div>
						<MenuButton
							class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
						>
							<span class="sr-only">Open user menu</span>
							<svg
								fill="none"
								height="20"
								viewBox="0 0 20 20"
								width="20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									clip-rule="evenodd"
									d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
									fill="#94A3B8"
									fill-rule="evenodd"
								/>
							</svg>
						</MenuButton>
					</div>
					<transition
						enter-active-class="transition ease-out duration-200"
						enter-from-class="transform opacity-0 scale-95"
						enter-to-class="transform opacity-100 scale-100"
						leave-active-class="transition ease-in duration-75"
						leave-from-class="transform opacity-100 scale-100"
						leave-to-class="transform opacity-0 scale-95"
					>
						<MenuItems
							class="origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
						>
							<MenuItem
								v-slot="{ active }"
								@click="editMenuByWeek()"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/pen.png"
										alt=""
									/>
									<span class="text-neutral-700 font-normal"
										>Chỉnh sửa chung</span
									>
								</div>
							</MenuItem>
							<MenuItem
								v-slot="{ active }"
								@click="
									duplicateWeekMenu(menuDetail?.start_date)
								"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/copy.png"
										alt=""
									/>
									<span class="text-neutral-700 font-normal"
										>Tạo bản sao</span
									>
								</div>
							</MenuItem>
							<MenuItem
								v-slot="{ active }"
								@click="sendMenuToParent"
								v-if="menuDetail.state === 'completed'"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/send.png"
										alt=""
									/>
									<span class="text-neutral-700 font-normal"
										>Gửi tới phụ huynh</span
									>
								</div>
							</MenuItem>
							<MenuItem
								v-slot="{ active }"
								@click="openDeleteModal"
								v-if="
									isWeekStartBeforeToday(
										menuDetail?.start_date
									)
								"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<img
										class="w-4 h-4"
										src="@/assets/images/icons/trash.png"
										alt=""
									/>
									<span class="text-neutral-700 font-normal"
										>Xoá thực đơn</span
									>
								</div>
							</MenuItem>
						</MenuItems>
					</transition>
				</Menu>
			</div>
			<div v-if="!isLoading" class="__record">
				<div class="__record__content">
					<div id="timetable__table__box" class="mt-10 relative">
						<div
							id="timetable__table"
							class="__record__table overflow-x-auto scroll-bar"
						>
							<div class="overflow-hidden sm:rounded-t-2xl w-fit">
								<table class="divide-y text-neutral-200">
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												scope="col"
											>
												Bữa ăn
											</th>
											<th
												v-for="i in menuDetail.day_of_weeks"
												:key="i"
												class="px-3 py-3 whitespace-nowrap border-l"
												scope="col"
												:style="{
													width:
														100 /
															menuDetail
																.day_of_weeks
																.length +
														'%',
													minWidth: '150px',
													maxWidth: '170px',
												}"
											>
												<div
													class="flex items-center justify-between w-full font-semibold"
												>
													<div
														class="uppercase text-xs text-neutral-600 tracking-wider"
													>
														{{
															i !== 7
																? `Thứ ${i + 1}`
																: 'Chủ nhật'
														}}
													</div>
													<Menu
														as="div"
														class="ml-3 relative"
													>
														<div>
															<MenuButton
																class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
															>
																<span
																	class="sr-only"
																	>Open user
																	menu</span
																>
																<svg
																	fill="none"
																	height="20"
																	viewBox="0 0 20 20"
																	width="20"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		clip-rule="evenodd"
																		d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																		fill="#94A3B8"
																		fill-rule="evenodd"
																	/>
																</svg>
															</MenuButton>
														</div>
														<transition
															enter-active-class="transition ease-out duration-200"
															enter-from-class="transform opacity-0 scale-95"
															enter-to-class="transform opacity-100 scale-100"
															leave-active-class="transition ease-in duration-75"
															leave-from-class="transform opacity-100 scale-100"
															leave-to-class="transform opacity-0 scale-95"
														>
															<MenuItems
																class="origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
															>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		editMenuByDay(
																			i
																		)
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																	>
																		<img
																			class="w-4 h-4"
																			src="@/assets/images/icons/pen.png"
																			alt=""
																		/>
																		<span
																			class="text-neutral-700 font-normal"
																			>Chỉnh
																			sửa
																			nội
																			dung</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		duplicateMenuByDay(
																			i
																		)
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																	>
																		<img
																			class="w-4 h-4"
																			src="@/assets/images/icons/copy.png"
																			alt=""
																		/>
																		<span
																			class="text-neutral-700 font-normal"
																			>Sao
																			chép
																			nội
																			dung</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		deleteMenuByDay(
																			i
																		)
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="p-2 px-4 bg-white z-10 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																	>
																		<img
																			class="w-4 h-4"
																			src="@/assets/images/icons/trash.png"
																			alt=""
																		/>
																		<span
																			class="text-neutral-700 font-normal"
																			>Xoá
																			nội
																			dung</span
																		>
																	</div>
																</MenuItem>
															</MenuItems>
														</transition>
													</Menu>
												</div>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												item, index
											) in menuDetail.meals"
											:key="item.id"
											:class="{ 'border-t': index !== 0 }"
											class="bg-white text-neutral-700"
										>
											<td
												class="p-4"
												style="vertical-align: top"
											>
												<div
													class="whitespace-nowrap text-sm"
												>
													{{ item.name }}
												</div>
											</td>
											<td
												v-for="i in menuDetail.day_of_weeks"
												:key="i"
												class="border-l p-4 space-y-2 items-start"
												style="min-width: 150px"
											>
												<div
													v-for="dish in getDishes(
														menuDetail,
														item.id,
														i
													)"
													:key="dish.id"
													class="ttext-sm text-neutral-700"
												>
													• {{ dish.dish.name }}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
	</div>
</template>